import { render, staticRenderFns } from "./CRiskAssess.vue?vue&type=template&id=f740da54"
import script from "./CRiskAssess.vue?vue&type=script&lang=js"
export * from "./CRiskAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f740da54')) {
      api.createRecord('f740da54', component.options)
    } else {
      api.reload('f740da54', component.options)
    }
    module.hot.accept("./CRiskAssess.vue?vue&type=template&id=f740da54", function () {
      api.rerender('f740da54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CRiskAssess.vue"
export default component.exports